//
// Module for the Account Transaction adjustment's page.
//
rs.module("content/participant/member/disabilityapplication/edit",

    [/* Dependencies */],

    function () {

        function initialize(jsSelectors, disabilityCausesGrid) {

            var disabilityForm = $.js(jsSelectors.disabilityForm);
            var disabilityAddLink = disabilityForm.js(jsSelectors.disabilityAddLink);

            // Handle the add link button for the salary grid
            disabilityAddLink.click(function () {
                disabilityCausesGrid.addRow();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);